import type { PrintOutInfoDtoInterface } from '@nts/std/interfaces';
import { OperationIdentity } from "./operation.identity";
import { Expose } from "@nts/std/serialization";

export class PrintOutInfoDto extends OperationIdentity implements PrintOutInfoDtoInterface {

    private _printerServiceAgentAddress: string;

    @Expose()
    get printerServiceAgentAddress(): string {
        return this.getValue<string>(() => this._printerServiceAgentAddress, 'printerServiceAgentAddress');
    }
    set printerServiceAgentAddress(value: string) {
        this.setValue<string>(() => { this._printerServiceAgentAddress = value; }, value, 'printerServiceAgentAddress');
    }

    private _printerName: string;

    @Expose()
    get printerName(): string {
        return this.getValue<string>(() => this._printerName, 'printerName');
    }
    set printerName(value: string) {
        this.setValue<string>(() => { this._printerName = value; }, value, 'printerName');
    }

    private _isDirectPrint: boolean;

    @Expose()
    get isDirectPrint(): boolean {
        return this.getValue<boolean>(() => this._isDirectPrint, 'isDirectPrint');
    }
    set isDirectPrint(value: boolean) {
        this.setValue<boolean>(() => { this._isDirectPrint = value; }, value, 'isDirectPrint');
    }

    private _dataToPrint: string;

    @Expose()
    get dataToPrint(): string {
        return this.getValue<string>(() => this._dataToPrint, 'dataToPrint');
    }
    set dataToPrint(value: string) {
        this.setValue<string>(() => { this._dataToPrint = value; }, value, 'dataToPrint');
    }

    private _excludeSpool: boolean;

    @Expose()
    get excludeSpool(): boolean {
        return this.getValue<boolean>(() => this._excludeSpool, 'excludeSpool');
    }
    set excludeSpool(value: boolean) {
        this.setValue<boolean>(() => { this._excludeSpool = value; }, value, 'excludeSpool');
    }

    private _fileName: string;

    @Expose()
    get fileName(): string {
        return this.getValue<string>(() => this._fileName, 'fileName');
    }
    set fileName(value: string) {
        this.setValue<string>(() => { this._fileName = value; }, value, 'fileName');
    }

}
